import React, { useState, useEffect, useContext } from "react";
import { Formik, FieldArray } from "formik";
// import { Editor } from "react-draft-wysiwyg";
import { ProductService } from "../../../services/product-service";
import { useHistory, useParams } from "react-router-dom";
import { notify, notifyWarning } from "../Toastmessage/Toastmessage";
import { IncomingInvoiceService } from "../../../services/incoming-invoice-service";
import { ToastContainer } from "react-toastify";
import { DataGrid } from "@material-ui/data-grid";
import { TablePagination } from "@material-ui/core";
import AuthContext from "../../../context/auth-context";
import { Modal } from "react-bootstrap";


export const IncomingInvoiceItems = (props) => {
  const ctx = useContext(AuthContext);

  const authPermission = localStorage.getItem("PermissionDetails");

  const [editHide, setHideEdit] = useState(true);
  const [deleteHide, setHideDelete] = useState(true);

  useEffect(() => {
    JSON.parse(authPermission).forEach(function (loca) {
      if (
        loca.access_module.module_name == "INCOMING_INVOICE" &&
        loca.permission_edit === true
      ) {
        setHideEdit(false);
      }
      if (
        loca.access_module.module_name == "INCOMING_INVOICE" &&
        loca.permission_delete === true
      ) {
        setHideDelete(false);
      }
    });
  }, [authPermission]);

  const [submitloading, setSubmitLoading] = useState(true);

  const [state, setState] = useState(false);

  const [grnItemID, setGrnItemID] = useState(0);


  const handleShow4 = (e) => {
    setState({ show4: true });
    setGrnItemID(e);
  };

  const handleClose = (e) => {
    setState({ show3: false });
  };

  let allItems = props.incomingInvoiceItemsInfo
  const [ incomingInvoiceItems, setIncomingInvoiceItems] = useState([]);

  const [products, setProducts] = useState([]);

  //add product data into group product

  const loadProduct = async (allItems) =>{
    try{
      const itemsData = allItems
      let finalArray = [];
      finalArray = await Promise.all(itemsData.map(async (product) => {
        const result = await ProductService.productDetailsID(product.product_id);
        product["product_name"] = result.name;
        return product;
      }))
      setIncomingInvoiceItems(finalArray);
    }catch (err) {
      //toast
      console.error(err);
    }
    
  }

  const productDetailsSearch = async () => {
    try {
      const result = await ProductService.productDetailsAllSearch();

      setProducts(result.results);
    } catch (err) {
      //toast
      console.error(err);
    }
  };

  useEffect(() => {
    productDetailsSearch();
  }, []);

  useEffect(() => {
    loadProduct(allItems);
  },[allItems])


  const onDelete = async () => {
    //todo extra validations
    setSubmitLoading(false);
    try {
      await IncomingInvoiceService.incomingInvoiceItemDelete(grnItemID);

      setSubmitLoading(true);
      notify("GRN item successfully deleted");
      handleClose();
      // incomingInvoicesSearch();
    } catch (err) {
      notifyWarning(err.response.data.message);
      setSubmitLoading(true);
      //show error toast
    }
  };

  const columns = [
    {
      field: "id",
      headerName: "ID",
      flex: 1,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
    },
    {
      field: "product.name",
      headerName: "Product Name",
      flex: 4,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        return <div>{params.row.product.name}</div>;
      },
    },
    {
      field: "quantity",
      headerName: "Quantity",
      flex: 2,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerAlign: "center",  // Aligns the header text
      align: "center",
    },
    {
      field: "unit_price",
      headerName: "Unit Price",
      flex: 2,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerAlign: "center",  // Aligns the header text
      align: "center",
      valueFormatter: (params) => {
        return new Intl.NumberFormat("en-US", {
          style: "decimal",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(params.value);
      },
    },
    {
      field: "discount_percentage",
      headerName: "Discount",
      flex: 2,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerAlign: "center",  // Aligns the header text
      align: "center",
    },
    {
      field: "line_total",
      headerName: "Line Total",
      flex: 2,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerAlign: "center",  // Aligns the header text
      align: "center",
      valueFormatter: (params) => {
        return new Intl.NumberFormat("en-US", {
          style: "decimal",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(params.value);
      },
    },
  ];

  return (
    <div className="ms-content-wrapper">
      <div>
        <ToastContainer />
      </div>
      <div className="row">
        <div className="col-md-12">
          <div className="ms-panel">
            <div>
              <Modal
                show={state.show4}
                onHide={handleClose}
                aria-labelledby="contained-modal-title-vcenter"
                centered
              >
                <Modal.Header>
                  <h3 className="modal-title has-icon ms-icon-round ">
                    Confirm Deletion
                  </h3>
                  <button type="button" className="close" onClick={handleClose}>
                    <span aria-hidden="true">×</span>
                  </button>
                </Modal.Header>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "2vh",
                  }}
                >
                  <h6 style={{ color: "red" }}>
                    Are you sure you want to remove this item ?
                  </h6>
                </div>
                <Modal.Footer>
                  <div className="col-md-2" hidden={submitloading}>
                    <div className="spinner spinner-7">
                      <div className="bounce1" />
                      <div className="bounce2" />
                      <div className="bounce3" />
                    </div>
                  </div>
                  <button
                    type="button"
                    className="btn btn-primary shadow-none"
                    style={{ backgroundColor: "red" }}
                    onClick={onDelete}
                  >
                    Delete
                  </button>

                  <button
                    type="button"
                    className="btn btn-light"
                    onClick={handleClose}
                  >
                    Cancel
                  </button>
                </Modal.Footer>
              </Modal>
            </div>
            <div className="ms-panel-body">
              <div style={{ width: "100%" }}>
                <DataGrid
                  rows={incomingInvoiceItems}
                  columns={columns}
                  hideFooter
                  autoHeight
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  // var bodyFormData = new FormData();
  // let allItems = props.incomingInvoiceItemsInfo
  // const [submitloading, setSubmitLoading] = useState(true);
  // const [ incomingInvoiceItems, setIncomingInvoiceItems] = useState([]);

  // const [products, setProducts] = useState([]);

  // //add product data into group product

  // const loadProduct = async (allItems) =>{
  //   try{
  //     const itemsData = allItems
  //     let finalArray = [];
  //     finalArray = await Promise.all(itemsData.map(async (product) => {
  //       const result = await ProductService.productDetailsID(product.product_id);
  //       product["product_name"] = result.name;
  //       return product;
  //     }))
  //     setIncomingInvoiceItems(finalArray);
  //   }catch (err) {
  //     //toast
  //     console.error(err);
  //   }
    
  // }

  // const productDetailsSearch = async () => {
  //   try {
  //     const result = await ProductService.productDetailsAllSearch();

  //     setProducts(result.results);
  //   } catch (err) {
  //     //toast
  //     console.error(err);
  //   }
  // };

  // useEffect(() => {
  //   productDetailsSearch();
  // }, []);

  // useEffect(() => {
  //   loadProduct(allItems);
  // },[allItems])

  // const onSubmitForm = async (
  //   values,
  //   { resetForm, setErrors, setStatus, setSubmitting, setFieldValue }
  // ) => {
  //   //todo extra validations
  //   setSubmitLoading(false);

  //   bodyFormData.append("invoiceItems", JSON.stringify(values.invoiceItems));

  //   try {
  //     await IncomingInvoiceService.incomingInvoiceItemUpdate(incomingInvoiceID, bodyFormData);

  //     setSubmitLoading(true);
  //     notify("Success Update Incoming Invoice");
  //   } catch (err) {
  //     setSubmitLoading(true);
  //     if (err.response.data.message !== undefined) {
  //       notifyWarning(err.response.data.message);
  //     } else {
  //       notifyWarning("Something Wrong");
  //     }
  //     //show error toast
  //   }
  // };

  // return (
  //   <div className="ms-content-wrapper">
  //     <div className="row">
  //       <div className="col-xl-12 col-md-12">
  //         <div className="ms-panel ms-panel-fh">
  //           <div className="ms-panel-body">
  //             <div className="row">
  //               <div className="col-sm-12">
  //                 <Formik
  //                   enableReinitialize={true}
  //                   initialValues={{
  //                     invoiceItems: incomingInvoiceItems,
  //                     // options: ["jared", "ian", "brent"],

  //                     // options: [],
  //                   }}
  //                   // validationSchema={Yup.object().shape({

  //                   // })}
  //                   onSubmit={onSubmitForm}
  //                   render={({
  //                     errors,
  //                     handleBlur,
  //                     handleChange,
  //                     touched,
  //                     values,
  //                     submitForm,
  //                     isValid,
  //                     setFieldValue,
  //                   }) => (
  //                     <div>
  //                       <div className="col-md-12 mb-6">
  //                         <FieldArray
  //                           name="invoiceItems"
  //                           render={(arrayHelpers) => (
  //                             <div>
  //                               {values.invoiceItems.map((item, index) => (
  //                                 <div key={index}>
  //                                   <div className="form-row">
  //                                     <div className="col-md-3 mb-3">
  //                                     <label htmlFor="validationCustom25">Product Name</label>
  //                                       <div className="input-group">
  //                                         <select
  //                                           onChange={handleChange}
  //                                           onBlur={handleBlur}
  //                                           type="text"
  //                                           className="form-control"
  //                                           id="validationCustom25"
  //                                           name={`invoiceItems.${index}.product_id`}
  //                                           value={item.product_id}
  //                                           disabled
  //                                         >
  //                                           {products.map((product) => {
  //                                             return (
  //                                               <option key={product.id} value={product.id}>{product.name}</option>
  //                                             )
  //                                           })}
  //                                         </select>
  //                                       </div>
  //                                     </div>
  //                                     <div className="col-md-2 mb-3">
  //                                       <label htmlFor="validationCustom25">Quantity</label>
  //                                       <div className="input-group">
  //                                         <input
  //                                           onChange={handleChange}
  //                                           onBlur={handleBlur}
  //                                           type="number"
  //                                           className="form-control"
  //                                           id="validationCustom26"
  //                                           placeholder=""
  //                                           required
  //                                           name={`invoiceItems[${index}].quantity`}
  //                                           defaultValue={item.quantity}
                                            
  //                                         />
  //                                       </div>
  //                                     </div>
  //                                     <div className="col-md-2 mb-3">
  //                                       <label htmlFor="validationCustom25">Unit Price</label>
  //                                       <div className="input-group">
  //                                         <input
  //                                           onChange={handleChange}
  //                                           onBlur={handleBlur}
  //                                           type="number"
  //                                           className="form-control"
  //                                           id="validationCustom26"
  //                                           placeholder=""
  //                                           required
  //                                           name={`invoiceItems[${index}].unit_price`}
  //                                           defaultValue={item.unit_price}
                                            
  //                                         />
  //                                       </div>
  //                                     </div>
  //                                     <div className="col-md-2 mb-3">
  //                                       <label htmlFor="validationCustom25">Line Total</label>
  //                                       <div className="input-group">
  //                                         <input
  //                                           onChange={handleChange}
  //                                           onBlur={handleBlur}
  //                                           type="number"
  //                                           className="form-control"
  //                                           id="validationCustom26"
  //                                           placeholder=""
  //                                           required
  //                                           name={`invoiceItems[${index}].line_total`}
  //                                           defaultValue={item.line_total}
                                            
  //                                         />
  //                                       </div>
  //                                     </div>
  //                                     <div className="col-md-3 mb-3">
  //                                     <label htmlFor="validationCustom25">Remove</label>
  //                                       <div>
  //                                         <button
  //                                           type="button"
  //                                           className="ms-btn-icon btn-primary"
  //                                           name="button"
  //                                           onClick={() =>
  //                                             arrayHelpers.remove(index)
  //                                           }
  //                                           style={{
  //                                             marginBottom: "2vh",
  //                                             backgroundColor: "red",
  //                                           }}
  //                                         >
  //                                           -
  //                                         </button>
  //                                       </div>
  //                                     </div>
  //                                   </div>
  //                                 </div>
  //                               ))}
  //                               <button
  //                                 type="button"
  //                                 className="ms-btn-icon btn-primary"
  //                                 name="button"
  //                                 onClick={() =>
  //                                   arrayHelpers.push({
  //                                     product_id: "",
  //                                     quantity: "",
  //                                     unit_price: "",
  //                                     line_total: "",
  //                                   })
  //                                 }
  //                                 style={{ marginBottom: "1vh" }}
  //                               >
  //                                 +
  //                               </button>
  //                             </div>
  //                           )}
  //                         />
  //                       </div>
  //                       <div className="col-md-2" hidden={submitloading}>
  //                         <div className="spinner spinner-7">
  //                           <div className="bounce1" />
  //                           <div className="bounce2" />
  //                           <div className="bounce3" />
  //                         </div>
  //                       </div>

  //                       <button
  //                         type="button"
  //                         className="btn btn-primary shadow-none float-right"
  //                         onClick={submitForm}
  //                       >
  //                         Save and Update
  //                       </button>
  //                     </div>
  //                   )}
  //                 />
  //               </div>
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   </div>
  // );
};

export default IncomingInvoiceItems;
